import '../../style/index.css';
import './index.css';
//# sourceMappingURL=css.js.map
